import { render } from "./KillSwitchView.vue?vue&type=template&id=6f262d00"
import script from "./KillSwitchView.vue?vue&type=script&lang=js"
export * from "./KillSwitchView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__